(() => {
  const bind = (root) => {
    if (!root || root.dataset.evDeliveryBound === 'true') return;
    root.dataset.evDeliveryBound = 'true';

    const form = root.querySelector('[data-ev-delivery-form]');
    const input = root.querySelector('[data-ev-delivery-cep]');
    const button = root.querySelector('[data-ev-delivery-submit]');
    const status = root.querySelector('[data-ev-delivery-status]');
    const result = root.querySelector('[data-ev-delivery-result]');
    const location = root.querySelector('[data-ev-delivery-location]');

    if (!form || !input || !button || !status || !result || !location) return;

    const setError = (message) => {
      result.hidden = true;
      status.textContent = message;
    };

    input.addEventListener('input', () => {
      const digits = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = digits.length > 5
        ? digits.slice(0, 5) + '-' + digits.slice(5)
        : digits;
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const cep = input.value.replace(/\D/g, '');

      if (!cep) {
        setError('Informe seu CEP.');
        return;
      }
      if (cep.length !== 8) {
        setError('Digite um CEP válido com 8 números.');
        return;
      }

      const originalText = button.textContent;
      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => controller.abort(), 8000);

      root.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = 'Consultando...';
      status.textContent = 'Consultando CEP...';
      result.hidden = true;

      try {
        const response = await fetch('https://viacep.com.br/ws/' + encodeURIComponent(cep) + '/json/', {
          method: 'GET',
          cache: 'no-store',
          signal: controller.signal
        });
        if (!response.ok) throw new Error('service');
        const data = await response.json();

        if (Object.prototype.hasOwnProperty.call(data, 'erro') && (data.erro === true || data.erro === 'true')) {
          setError('Não encontramos esse CEP. Confira os números e tente novamente.');
          return;
        }
        if (!data.localidade || !data.uf) throw new Error('service');

        const place = data.localidade + '/' + data.uf;
        location.textContent = place;
        result.hidden = false;
        status.textContent = 'Prazos encontrados para ' + place + '.';
      } catch (error) {
        setError('Não foi possível consultar o CEP agora. Tente novamente em alguns instantes.');
      } finally {
        window.clearTimeout(timeoutId);
        root.removeAttribute('aria-busy');
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  };

  const init = () => document.querySelectorAll('[data-ev-delivery-estimator]').forEach(bind);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();